<script lang="ts">
import { defineComponent, inject, PropType, ref, watch } from "vue";
import Steps from "@/components/Steps.vue";
import formatUtils from "@/businesslogic/utils/formatUtils";
import Beitrag from "@/components/Beitrag.vue";
import EmailOderHerunterladen from "@/components/vorschlag/EmailOderHerunterladen.vue";
import { NavvItem } from "@/model/NavItem";
import Produktmodul from "@/components/module/Produktmodul.vue";
import ProduktmoduleBL from "@/components/module/produktmoduleBL";
import LeistungstabelleEineLinie from "@/components/leistungstabelle/LeistungstabelleEineLinie.vue";
import LeistungenBL from "@/components/leistungstabelle/LeistungenBL";
import TarifauswahlEineLinie from "@/components/tarif/TarifauswahlEineLinie.vue";
import Maklerrabatt from "@/components/maklerrabatt/Maklerrabatt.vue";
import formValidierung from "@/businesslogic/formValidierung";
import HugRabatt from "@/components/HugRabatt.vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "TarifBL",
  emits: ["prev-page", "next-page", "goto-page", "handle-error"],
  components: {
    HugRabatt,
    LeistungstabelleEineLinie,
    Steps,
    Beitrag,
    EmailOderHerunterladen,
    Produktmodul,
    TarifauswahlEineLinie,
    Maklerrabatt,
  },
  props: {
    navItems: Object as PropType<NavvItem[]>,
  },
  setup(props, { emit }) {
    const piniaStore = useFormStore();
    const istSichtbar: any = inject("istSichtbar");
    const wechsleSichtbarkeit: any = inject("wechsleSichtbarkeit");
    const { formatCurrency } = formatUtils();
    const fehler = ref({} as any);
    const produktmodule = ref(ProduktmoduleBL);
    const leistungen = ref(LeistungenBL);
    const aktiveLinie = 2;

    const { validiereRabatt } = formValidierung();
    let validiert = false;

    const tib = "https://www.gev-versicherung.de/downloads/pdf/TI-TIB-BL-2008.pdf";

    function eingabenSindValide() {
      validiert = true;
      validiereRabatt(piniaStore.state, fehler, validiert);

      return Object.keys(fehler.value).length == 0;
    }

    watch(
      () => piniaStore.state.tarifinformationen.abschlagZuschlagHoehe,
      () => {
        validiert = true;
        validiereRabatt(piniaStore.state, fehler, validiert);
      },
    );

    const nextPage = () => {
      if (eingabenSindValide()) {
        emit("next-page", {
          pageIndex: 1,
        });
      } else {
        document.querySelector("div#tariffOptionsTable")?.scrollIntoView({ behavior: "smooth" });
      }
    };

    return {
      props,
      piniaStore,
      wechsleSichtbarkeit,
      istSichtbar,
      fehler,
      produktmodule,
      leistungen,
      aktiveLinie,
      formatCurrency,
      tib,
      nextPage,
    };
  },
});
</script>

<template>
  <steps v-bind:items="navItems" :active="1" @goto-page="$emit('goto-page', $event)" />

  <section>
    <tarifauswahl-eine-linie produktbezeichnung="Bauleistung" />
    <leistungstabelle-eine-linie :inhalt="leistungen" :link="tib" />

    <produktmodul :produktmodule="produktmodule" :zeige-icons="true"></produktmodul>

    <div class="o-grid o-grid--align-middle u-mar-t-2">
      <div class="o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y">
        <h2 class="u-form-heading unset-text-align">Rabatte</h2>
      </div>
      <hug-rabatt />
    </div>

    <maklerrabatt :fehler="fehler" />

    <beitrag @next-page="nextPage" />
    <email-oder-herunterladen produkt="bl" tracking-zusatz="tarif" />
  </section>
</template>

<style lang="scss">
.selbstbeteiligung {
  font-size: 1.2em;
  font-weight: 700;
}
</style>
